// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorAlert_container__1IkcT"};